<template>
  <div class="bg-white shadow">
    <div
      class="px-2 py-2 lg:mx-auto lg:px-4 lg:border-t lg:border-cool-gray-200 text-sm"
    >
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "MainHeader",
  props: {},
  computed: {}
};
</script>

<style scoped></style>
